import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getUnitById, defaultUnitData, updateUnit, createUnit } from '@/api/locations/units';
import { getBranchById } from '@/api/locations/branches';
import { getAdmins } from '@/api/admins';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { ACCOUNT_MANAGER, INVOICE_MANAGER, ORDER_MANAGER, READ_ONLY, REGIONAL_MANAGER, UNIT_MANAGER } from '@/constants/roles.constants';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultUnitData);
    this.managers = [];
    this.selectedAdmin = [];
    this.loading = false;
    this.rules = {
      adminId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      unitTypes: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      code: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      sequence: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
    this.unitTypes = [{
      value: 'Cona',
      label: 'Cona'
    }, {
      value: 'Agent',
      label: 'Agent'
    }, {
      value: 'Godown',
      label: 'Godown'
    }];
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    // get unit managers
    // this.fetchUnitManagers();
    this.fetchAllManagers();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultUnitData);
      this.formData.branchId = parseInt(this.$route.params && this.$route.params.branchId);
      // fetch branch info
      this.fetchBranch(this.formData.branchId);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getUnitById(id);
      this.formData = data;
      // populate selected admins
      if (data.admin && data.admin.length) {
        this.selectedAdmin = data.admin.map(admin => admin.id);
      }
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchBranch(branchId) {
    try {
      const branch = await getBranchById(branchId);
      this.formData.cityId = branch.cityId;
      this.formData.stateId = branch.stateId;
      this.formData.countryId = branch.countryId;
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchUnitManagers() {
    this.managers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: 3,
      filter: {
        enabled: '$eq',
        adminsRoleId: '$eq'
      }
    }));
  }
  async fetchAllManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [UNIT_MANAGER, INVOICE_MANAGER, ORDER_MANAGER, ACCOUNT_MANAGER, READ_ONLY, REGIONAL_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.managers = allManagers.data;
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.country = {
        id: this.formData.countryId
      };
      this.formData.state = {
        id: this.formData.stateId
      };
      this.formData.city = {
        id: this.formData.cityId
      };
      this.formData.branch = {
        id: this.formData.branchId
      };
      // save multiple admins
      if (this.selectedAdmin.length) {
        this.formData.admin = [];
        this.selectedAdmin.forEach(admin => {
          this.formData.admin.push({
            id: admin
          });
        });
      }
      if (this.isEdit) {
        await updateUnit(this.formData.id, this.formData);
      } else {
        await createUnit(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Unit saved',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/units/list/' + this.formData.branchId,
        query: this.$route.query
      });
    } catch (err) {
      this.loading = false;
      throw err;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'UnitDetail',
  components: {}
})], default_1);
export default default_1;